module.exports = __webpack_public_path__ + "static/img/icon-draft.af17d294.svg";